
export default function Logo(props){

    return(
        <img src={props.src} alt={props.alt?props.alt:""}  width={props.width?props.width:"auto"} height={props.height?props.height:"auto"}/>
    )
}